import React from "react";

/**
 * AppTabs — wrap-friendly tab bar. Never produces horizontal scroll.
 * items: [{ key, label, count? }]
 */
export function AppTabs({ items, value, onChange, className = "", testId }) {
    return (
        <div
            role="tablist"
            data-testid={testId || "app-tabs"}
            className={`flex flex-wrap gap-2 ${className}`}
        >
            {items.map((it) => {
                const active = it.key === value;
                return (
                    <button
                        key={it.key}
                        role="tab"
                        aria-selected={active}
                        data-testid={`app-tab-${it.key}`}
                        onClick={() => onChange?.(it.key)}
                        className={
                            active
                                ? "inline-flex items-center gap-2 rounded-full bg-md-primary px-4 py-2 text-xs font-semibold uppercase tracking-wider text-md-primary-fg"
                                : "inline-flex items-center gap-2 rounded-full border border-md-border bg-md-surface px-4 py-2 text-xs font-semibold uppercase tracking-wider text-md-text-2 hover:bg-md-surface-2 hover:text-md-text"
                        }
                    >
                        <span>{it.label}</span>
                        {typeof it.count === "number" && (
                            <span className={active ? "rounded-full bg-md-primary-fg/15 px-2 py-0.5 text-[10px]" : "rounded-full bg-md-surface-2 px-2 py-0.5 text-[10px]"}>
                                {it.count}
                            </span>
                        )}
                    </button>
                );
            })}
        </div>
    );
}

export default AppTabs;
